__turbopack_context__.v({
  "root": "PlasmicSpinnerIcon-module__m2s_Zq__root",
  "rootdisabled": "PlasmicSpinnerIcon-module__m2s_Zq__rootdisabled",
  "spinnerIcon": "PlasmicSpinnerIcon-module__m2s_Zq__spinnerIcon",
  "spinnerIcon2": "PlasmicSpinnerIcon-module__m2s_Zq__spinnerIcon2",
  "spinnerIcon2light": "PlasmicSpinnerIcon-module__m2s_Zq__spinnerIcon2light",
  "spinnerIcon3": "PlasmicSpinnerIcon-module__m2s_Zq__spinnerIcon3",
  "spinnerIcon3disabled": "PlasmicSpinnerIcon-module__m2s_Zq__spinnerIcon3disabled",
  "spinnerIcondisabled": "PlasmicSpinnerIcon-module__m2s_Zq__spinnerIcondisabled",
});
